"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkify = exports.arrayRepeat = exports.removeItem = exports.findIndexLeast = exports.arraySplit = exports.groupOneBy = exports.groupBy = exports.shuffle = exports.arraySwap = exports.randomArrayItem = exports.normalize = exports.arrayDistinct = exports.arraysCompareDistinct = exports.arraysCompare = exports.arrayFirstResult = exports.arrayCount = exports.arrayAverage = exports.arrayMin = exports.arrayMax = exports.arrayCompare = exports.arrayCompareG = void 0;
const types_1 = require("../types");
const calc_1 = require("./calc");
function arrayCompareG(arr, cond) {
    if (!Array.isArray(arr) || arr.length <= 0) {
        return null;
    }
    let result = null;
    for (let i = 0; i < arr.length; i++) {
        const current = arr[i];
        if (cond(current, result)) {
            result = current;
        }
    }
    return result;
}
exports.arrayCompareG = arrayCompareG;
function arrayCompare(arr, absolute, cond) {
    if (!Array.isArray(arr) || arr.length <= 0) {
        return null;
    }
    let max = arr[0];
    for (let i = 1; i < arr.length; i++) {
        const e = absolute ? Math.abs(arr[i]) : arr[i];
        if (cond(e, max)) {
            max = e;
        }
    }
    return max;
}
exports.arrayCompare = arrayCompare;
function arrayMax(arr, absolute = false) {
    return arrayCompare(arr, absolute, (e, max) => e > max);
}
exports.arrayMax = arrayMax;
function arrayMin(arr, absolute = false) {
    return arrayCompare(arr, absolute, (e, min) => e < min);
}
exports.arrayMin = arrayMin;
function arrayAverage(arr, absolute = false) {
    if (!Array.isArray(arr) || arr.length <= 0) {
        return 0;
    }
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
        const e = absolute ? Math.abs(arr[i]) : arr[i];
        sum += e;
    }
    return sum / arr.length;
}
exports.arrayAverage = arrayAverage;
function arrayCount(arr, condition) {
    if (!arr || !arr.length) {
        return 0;
    }
    let count = 0;
    arr.forEach(a => {
        if (condition(a)) {
            ++count;
        }
    });
    return count;
}
exports.arrayCount = arrayCount;
function arrayFirstResult(arr, mapper) {
    if (arr === null || arr === void 0 ? void 0 : arr.length) {
        for (let i = 0; i < arr.length; ++i) {
            const r = mapper(arr[i]);
            if (r) {
                return r;
            }
        }
    }
    return false;
}
exports.arrayFirstResult = arrayFirstResult;
function arraysCompare(base, target, comparator) {
    if (!base || !target) {
        return null;
    }
    const compare = comparator || types_1.Comparator.Default;
    const result = {
        missing: [],
        extra: [],
        diff: 0,
    };
    for (let i = 0; i < base.length; ++i) {
        const baseItem = base[i];
        const targetItem = target[i];
        if (compare(baseItem, targetItem)) {
            continue;
        }
        result.missing.push(baseItem);
    }
    for (let i = base.length; i < target.length; ++i) {
        result.extra.push(target[i]);
    }
    result.diff = result.missing.length + result.extra.length;
    return result;
}
exports.arraysCompare = arraysCompare;
function arraysCompareDistinct(base, target) {
    if (!base || !target) {
        return null;
    }
    const baseSet = new Set(base);
    const targetSet = new Set(target);
    const result = {
        missing: [],
        extra: [],
        diff: 0,
    };
    for (const item of baseSet) {
        if (!targetSet.has(item)) {
            result.missing.push(item);
        }
        else {
            // reduce iterations for 'extra'
            targetSet.delete(item);
        }
    }
    for (const item of targetSet) {
        // all items left in 'target' is missing in 'base'
        result.extra.push(item);
    }
    result.diff = result.missing.length + result.extra.length;
    return result;
}
exports.arraysCompareDistinct = arraysCompareDistinct;
function arrayDistinct(arr) {
    return Array.from(new Set(arr || []));
}
exports.arrayDistinct = arrayDistinct;
function normalize(arr) {
    if (arr.length === 0) {
        return arr;
    }
    const min = arrayMin(arr);
    const max = arrayMax(arr);
    const dist = max - min;
    if (Math.abs(dist) < 0.000001) { // almost zero
        return arr.map(() => 1);
    }
    return arr.map(x => (x - min) / dist);
}
exports.normalize = normalize;
function randomArrayItem(arr) {
    if (!arr.length) {
        return null;
    }
    const i = (0, calc_1.random)(0, arr.length - 1);
    return arr[i];
}
exports.randomArrayItem = randomArrayItem;
function arraySwap(arr, i1, i2) {
    const x = arr[i1];
    arr[i1] = arr[i2];
    arr[i2] = x;
}
exports.arraySwap = arraySwap;
function shuffle(arr, slice = true) {
    const res = (slice ? arr === null || arr === void 0 ? void 0 : arr.slice() : arr) || [];
    for (let i = 0; i < res.length - 1; ++i) {
        const nextIndex = (0, calc_1.random)(i + 1, res.length - 1);
        arraySwap(res, i, nextIndex);
    }
    return res;
}
exports.shuffle = shuffle;
function groupBy(arr, grouper) {
    const result = {};
    arr.forEach(item => {
        const k = grouper(item);
        let g = result[k];
        if (!g) {
            g = [];
            result[k] = g;
        }
        g.push(item);
    });
    return result;
}
exports.groupBy = groupBy;
function groupOneBy(arr, grouper) {
    const result = {};
    arr.forEach(item => {
        const k = grouper(item);
        result[k] = item;
    });
    return result;
}
exports.groupOneBy = groupOneBy;
function arraySplit(arr, predicate) {
    const trueArr = [];
    const falseArr = [];
    arr.forEach(a => {
        (predicate(a)
            ? trueArr
            : falseArr).push(a);
    });
    return [trueArr, falseArr];
}
exports.arraySplit = arraySplit;
function findIndexLeast(num, arr, sort = false) {
    if (sort) {
        arr.sort();
    }
    return arr.findIndex(i => i > num);
}
exports.findIndexLeast = findIndexLeast;
function removeItem(array, item) {
    const index = typeof item === 'function'
        ? array.findIndex(item)
        : array.indexOf(item);
    if (index < 0) {
        return null;
    }
    return array.splice(index, 1)[0];
}
exports.removeItem = removeItem;
function arrayRepeat(factory, count = 1) {
    const res = [];
    for (let i = 0; i < count; ++i) {
        res.push(types_1.Getter.getValue(factory));
    }
    return res;
}
exports.arrayRepeat = arrayRepeat;
function chunkify(array, size) {
    return array.reduce((res, item) => {
        let arr = res[res.length - 1];
        if (!arr || arr.length >= size) {
            arr = [];
            res.push(arr);
        }
        arr.push(item);
        return res;
    }, []);
}
exports.chunkify = chunkify;
//# sourceMappingURL=arrays.js.map